import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

import Avatar from './avatar/avatar';

import InputSearch from './header/inputSearch';

import Logo from '../assets/header/logo.svg';

const Header = () => {
  const currentCompany = useSelector(
    (state: RootState) => state.company.currentCompany
  );

  return (
    <header>
      <div className="flex items-center justify-between h-24 p-6">
        <div className="flex gap-2 items-center">
          <img src={Logo} alt="Logo" />
          <div className="flex items-center gap-2 font-roboto text-xl">
            <h1>CloudCollect</h1>
            <div>|</div>
            <h2>{currentCompany?.name}</h2>
          </div>
        </div>
        <div className="flex items-center gap-6">
          <InputSearch />
          <Avatar />
        </div>
      </div>
    </header>
  );
};

export default Header;
